<template>
    <div>

        <rkm-alert v-if="model && model.exportacao && model.exportacao.data">
            <strong>Última exportação:</strong> {{ model.exportacao.data }} - {{ model.exportacao.profissional }}
        </rkm-alert>

        <Tabs
            v-if="loaded"
            ref="Tabs"
            :data="{ form, model }"
        />

        <ModalPermissao
            ref="RkmModalPermissao"
            @handlePermission="handlePermission"
            @handleExitSupervisor="handleExitSupervisor"
        />
    </div>
</template>

<script>

// Utils
import validaCpf from '@/utils/validations/cpf'
import validaCns from '@/utils/validations/cns'

// Mixins
import { repository, stringCase, data, object, formats, error } from "@/mixins";

// Vuex.
import { mapActions } from "vuex";

// Components
import Tabs from './Tabs'
import ModalPermissao from './components/permissao/Modal'

export default {
    components: { Tabs, ModalPermissao },
    created() {

        this.repositories = {
            cadastroIndividual: this.getConectaSusRepository('atencaoBasica.cadastroIndividual')
        }

        this.load()
    },
    data: () => ({
        additionals: null,
        form: {},
        model: {},
        loaded: false,
        utils: {
            validaCpf,
            validaCns
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.id) {
                this.setLoading()

                this.repositories.cadastroIndividual.edit(this.id)
                    .then(response => {

                        this.additionals = Object.assign(response.data.additionals)
                        this.model = Object.assign(response.data.model)
                        this.form = Object.assign(response.data.form)

                        if (!this.utils.validaCpf(response.data.model.cidadao.cpf)
                            && !this.utils.validaCns(response.data.model.cidadao.cns)) {

                            const msg = `Para prosseguir com o preenchimento do formulário, é necessário fornecer os dados do
                                supervisor, uma vez que o CPF e CNS do paciente estão incorretos. Deseja continuar?`

                            this.showAlert(msg, 'Atenção')

                            const confirm = async () => {

                                this.$refs.RkmModalPermissao.open()
                            }

                            const cancel = async () => {

                                this.$emit('handleExitSupervisor')
                            }

                            this.showConfirmation(msg, confirm, cancel)

                            return false
                        } else {

                            if (!response.data.model.hasCadastro && response.data.model.hasInformacaoPaciente) {

                                this.showAlert(`Paciente não possui um cadastro individual, as informações exibidas
                                    correspondem ao cadastro do paciente.`, 'Atenção')
                            }
                        }

                        if (this.model.alteracao.dataCadastro) {
                            this.$emit('handleCadastro')
                        }

                        this.loaded = true

                        this.$emit('loaded', {additionals: this.additionals, model: this.model})
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handlePermission(supervisorId){

            this.model.cadastro.supervisorId = supervisorId

            if (this.model.alteracao.dataCadastro) {
                this.$emit('handleCadastro')
            }

            this.loaded = true
        },
        handleExitSupervisor(){

            this.$emit('handleExitSupervisor')
        },
        save() {

            this.$refs['Tabs'].validate()
                .then(valid => {

                if (!valid) return

                    this.setLoading()

                    this.repositories.cadastroIndividual.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()

                            if(this.model && this.model.cadastroDomiciliar.id){
                                    const mensagem = 'Deseja atualizar também o Cadastro Domiciliar?'
                                    
                                    const confirmar = async () => {

                                        this.showSaveNotification()
                                         this.$emit('save', data)

                                        this.$router.push({
                                            name:'atencao-basica-cadastro-domiciliar-edit', 
                                            params: {id: this.model.cadastroDomiciliar.id}
                                        })
                                    }
                                    const cancelar =  async () => {
                                        this.showSaveNotification()
                                        this.$emit('save', data)
                                    };
                                    this.showConfirmation(mensagem, confirmar, cancelar);
                                    
                            }else{
                                this.showSaveNotification()
                                this.$emit('save', data)
                            }                         
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())

            })
        },
        prepareData() {

            const pacienteId = this.id

            const cadastro = this.clone(this.model.cadastro)
            cadastro.usuario_id = cadastro.usuario.id
            cadastro.dataUsuarioResponsavel = this.getFormatedDate(cadastro.dataUsuarioResponsavel, 'YYYY-MM-DD')

            const cidadao = this.clone(this.model.cidadao)
            const condicao = this.clone(this.model.condicao)
            const informacao = this.clone(this.model.informacao)

            cidadao.ocupacaoId = cidadao.ocupacao ? cidadao.ocupacao.id : null
            informacao.ocupacaoId = informacao.ocupacao ? informacao.ocupacao.id : null
            informacao.comunidadeTradicionalId = informacao.comunidadeTradicionalQual ? informacao.comunidadeTradicionalQual.id : null
            informacao.motivoSaidaData = this.getFormatedDate(informacao.motivoSaidaData, 'YYYY-MM-DD')

            if (informacao.obitoEm) {

                informacao.obitoEm = this.getFormatedDate(informacao.obitoEm, 'DD/MM/YYYY') + ' ' + (informacao.horaObito || '00:00:00')

                informacao.obitoCidId = informacao.obitoCid.id

                delete(informacao.obitoCid)
            }

            const recusaCadastro = this.clone(this.model.recusaCadastro)
            const situacaoRua = this.clone(this.model.situacaoRua)
            const informacaoSocioeconomica = this.clone(this.model.informacaoSocioeconomica)

            const origem = 'atencaoBasica'

            delete(cadastro.usuario)

            return this.camelObjectKeysToSnakeRecursive({
                pacienteId, cadastro, cidadao, condicao, informacao, recusaCadastro, situacaoRua, origem, informacaoSocioeconomica
            })
        },
    },
    mixins: [repository, stringCase, data, object, formats, error],
    props: {
        id: { type: Number, default: null }
    }
}
</script>